import { render, staticRenderFns } from "./AddToMyCollectionsModal.vue?vue&type=template&id=0309ba0b&scoped=true&"
import script from "./AddToMyCollectionsModal.vue?vue&type=script&lang=ts&"
export * from "./AddToMyCollectionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddToMyCollectionsModal.vue?vue&type=style&index=0&id=0309ba0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309ba0b",
  null
  
)

export default component.exports